import React from 'react'
import { Button,List, Dropdown, Table , Statistic, Dimmer} from 'semantic-ui-react';
import _ from 'lodash'
import moment from 'moment'
import PropTypes from "prop-types";
import Panel from '../../../components/shared/Panel';
import { Currencies } from '../../../components/shared/currencies';
import { ReservationStatusesEnums } from '../../../components/shared/statustypes';
import { dateFormatSpaces } from '../../../components/shared/constants';
import { useTextResources } from '../../../language';

const BlocksList = ({onBlockSelected,onNewBlockClicked,reservations,onBlockCanceled,blockActive,isDirty,onBlockWashed}) => {
    const blocks = _.filter(reservations, "IsBlock")
    const fits = _.filter(reservations,r => {return !r.IsBlock}).length;
    const reservedBlocks = _.filter(blocks,block => { return block.Reservation.StatusId === ReservationStatusesEnums.Reserved})
    const totalBlockRooms = _.sumBy(reservedBlocks,b => {return Number(b.Reservation.Quantity)})
    const totalAdults = _.sumBy(reservedBlocks,b => {return Number(b.Reservation.Adults)})
    const totalChildrens = _.sumBy(reservedBlocks,b => {return Number(b.Reservation.Children)})
    const totalInfants = _.sumBy(reservedBlocks,b => {return Number(b.Reservation.Infants)})
    const text = useTextResources()
    
    const calcGrossDailyRate = block_reservation => {
        let fits = _.filter(reservations, r=>r.ParentReservationID === block_reservation.Id)
        let fitsTotal = _.sumBy(fits, r => r.Reservation.Id !== 0 ? parseFloat(r.Reservation.TotalAmountProductCurrentAfterTax) : 0)
        let price =  parseFloat(block_reservation.TotalAmountProductCurrentAfterTax + fitsTotal).toFixed(2)
        const currency = Currencies[block_reservation.CurrencyId]
        return `${price} ${currency?currency.symbol:''}` 
    }

    const cancelBlcokCheck = (block) => {
        if(!block.Reservation.Id) return true
        else if(!block.IsPrimaryReservationInGroup) return false
        else{
            let blcokReservedExists = _.find(blocks,b => {return !b.IsPrimaryReservationInGroup && b.Reservation.StatusId === ReservationStatusesEnums.Reserved})
            if(blcokReservedExists) return true
            else return false
        }
    }

    return (
        <Panel header={
            <div>
                <Dimmer active={isDirty} inverted style={{opacity: 0.5}}/>
                <Button onClick={onNewBlockClicked} positive>{text('AddNewBlock')}</Button>
                <div className="header" style={{float:'right'}}>
                <span>{text('TotalRooms')} {totalBlockRooms + '/' + (totalBlockRooms + fits)}<span style={{width: "20px", display: "inline-block"}}> </span>{text('TotalPax')} {totalAdults + '/' + totalChildrens + '/' + totalInfants} </span>
            </div>
            </div>
          }>
              <Dimmer active={isDirty} inverted style={{opacity: 0.5}}/>
                <List selection className="blocklist">
                    {
                        _.map(blocks,block => {
                            const block_reservation = block.Reservation
                            const block_active = blockActive.Reservation.Id === block_reservation.Id
                            const BlockActiveFits = _.filter(reservations, ["ParentReservationID", block_reservation.Id])
                            return(
                                <List.Item active={block_active} onClick={() => onBlockSelected(block)} key={block_reservation.Id}>
                                    <Table>
                                        <Table.Body>
                                            <Table.Row>
                                                <Table.Cell width="3">
                                                    {moment(block_reservation.CheckInDate).format(dateFormatSpaces)}-{moment(block_reservation.CheckOutDate).format(dateFormatSpaces)}
                                                </Table.Cell>
                                                <Table.Cell width="2">
                                                    {block_reservation.RoomTypeName || text('RoomType')}
                                                </Table.Cell>
                                                <Table.Cell width="2">
                                                    <Statistic size="mini">
                                                        <Statistic.Label>{text('Blocked')+"/"+text('Picked')}</Statistic.Label>
                                                        <Statistic.Value>{Number(block_reservation.Quantity) + _.sumBy(BlockActiveFits, fit => (fit.Reservation.Id !== 0) ? fit.Reservation.Quantity : 0)}/{_.sumBy(BlockActiveFits, fit => (fit.Reservation.Id !== 0) ? fit.Reservation.Quantity : 0)}</Statistic.Value>
                                                    </Statistic>
                                                </Table.Cell>
                                                <Table.Cell width="2">
                                                {text('Pax')} {block_reservation.Adults}/{block_reservation.Children}/{block_reservation.Infants}
                                                </Table.Cell>
                                                <Table.Cell width="3">
                                                {text('ResNum')} {block_reservation.Number}
                                                </Table.Cell>
                                                <Table.Cell textAlign="right" width="3">
                                                    <Statistic size="mini">
                                                        <Statistic.Label>{text('GrossDailyRate')}</Statistic.Label>
                                                        <Statistic.Value>{calcGrossDailyRate(block_reservation)}</Statistic.Value>
                                                    </Statistic>
                                                </Table.Cell>
                                                <Table.Cell textAlign="right" width="1">
                                                    <Dropdown disabled={!block_active}   direction="left" icon={{name:"ellipsis vertical", size: "large"}}>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item disabled={cancelBlcokCheck(block)} icon="trash alternate outline" text={text("Cancel")} onClick={() => {onBlockCanceled(block_reservation)}}/>
                                                            <Dropdown.Item disabled={!BlockActiveFits.length} icon="trash alternate outline" text={text("Wash")} onClick={onBlockWashed}/>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                                </List.Item>
                            )
                        })
                    }
                </List>
            </Panel>
    )
}
BlocksList.propTypes = {
    onBlockSelected: PropTypes.func.isRequired,
    onNewBlockClicked:PropTypes.func,
    onBlockCanceled:PropTypes.func,
    reservations:PropTypes.any,
    blockActive:PropTypes.any,
    isDirty:PropTypes.bool,
    onBlockWashed:PropTypes.func
}

export default BlocksList